/*

To add a heading using our md parser, you need:
  - either a new line, or a new line followed by 1-3 spaces (only one is rendered, 4 spaces = code block),
  - followed by 1-6 #,
  - followed by any number of spaces (only one is rendered),
  - followed by your heading text

So we need regex that matches:
  - either the start of any line, or the start of any line followed by 1-3 spaces,
  - followed by 1-6 #,
  - followed by any number of spaces,
  - followed by any character except space or new line

And then we replace any match with this final character

*/

const headingRegEx: RegExp =
  /(^|^ {1}|^ {2}|^ {3})(#{1}|#{2}|#{3}|#{4}|#{5}|#{6}) +[^\n ]/gm;

function replacer(match: string) {
  return match.slice(-1);
}

export function removeMarkdownHeadings(markdown: string) {
  return markdown.replace(headingRegEx, replacer);
}
